import { ChatSession } from '../types/ChatSession';

/**
 * Utility function to check if a chat session has unread messages
 * This function is used consistently across all components to ensure
 * the same logic is applied for unread message detection
 */
export const hasUnreadMessages = (session: ChatSession): boolean => {
  // Handle edge cases with dates
  if (!session.last_message_sent_at) {
    return false;
  }

  const lastMessageSent = new Date(session.last_message_sent_at);
  
  // Check if the message date is valid and not the epoch date (1970-01-01)
  const timestamp = lastMessageSent.getTime();
  const isEpochDate = session.last_message_sent_at.includes('1970-01-01') || timestamp <= 0;
  
  if (isNaN(timestamp) || isEpochDate) {
    console.log(`❌ Session ${session.id}: Invalid or epoch date: ${session.last_message_sent_at}, timestamp: ${timestamp}, isEpoch: ${isEpochDate}`);
    return false;
  }

  // If there's no last_read_expert, consider as unread only if there's a real message
  if (!session.last_read_expert) {
    console.log(`🔴 Session ${session.id}: No last_read_expert, considering as unread`);
    return true;
  }

  const lastReadExpert = new Date(session.last_read_expert);
  
  // Check if read date is valid
  if (isNaN(lastReadExpert.getTime())) {
    return false;
  }

  return lastMessageSent > lastReadExpert;
}; 